import cn from "@/utils/cn"
import { ComponentPropsWithoutRef } from "react"

type ActionButtonVariant = "default" | "danger" | "warning"

type ActionButtonProps = ComponentPropsWithoutRef<"button"> & {
  variant?: ActionButtonVariant
  children: React.ReactNode
}

const ActionButton = ({
  variant = "default",
  className,
  children,
  ...props
}: ActionButtonProps) => {
  const variantStyles = {
    default: "bg-gray-100 text-primary/90 hover:bg-gray-200",
    danger: "bg-red-100/70 text-red-700  hover:bg-red-100 ",
    warning: "bg-yellow-100/70 text-yellow-700  hover:bg-yellow-100",
  }

  return (
    <button
      className={cn(
        "cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-semibold leading-6 transition-colors",
        "disabled:cursor-not-allowed disabled:opacity-50",
        variantStyles[variant],
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}

export default ActionButton
